export const searchList1 = [
  {
    id: "search1",
    photo: "https://dongsooo.github.io/imgs/img/05_seach-chill.jpg",
    title: "Chill",
  },
  {
    id: "search2",
    photo: "https://dongsooo.github.io/imgs/img/05_seach-CityPop.jpg",
    title: "시티팝",
  },
  {
    id: "search3",
    photo: "https://dongsooo.github.io/imgs/img/05_seach-travel.jpg",
    title: "여행",
  },
  {
    id: "search4",
    photo: "https://dongsooo.github.io/imgs/img/05_seach-memory.jpg",
    title: "추억",
  },
  {
    id: "search5",
    photo: "https://dongsooo.github.io/imgs/img/05_seach-relaxing.jpg",
    title: "릴렉싱",
  },
  {
    id: "search6",
    photo: "https://dongsooo.github.io/imgs/img/05_seach-drive.jpg",
    title: "드라이브",
  },
  {
    id: "search7",
    photo: "https://dongsooo.github.io/imgs/img/05_seach-rest.jpg",
    title: "휴식",
  },
  {
    id: "search8",
    photo: "https://dongsooo.github.io/imgs/img/05_seach-summer.jpg",
    title: "여름",
  },
];
